import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-16 scroll-mt-20" style={{ backgroundColor: 'oklch(var(--background-100))' }}>
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">读者热评</h2>
          <p className="text-sm text-foreground-500 mt-2">真实读者 · 真实评价 · 真实感受</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="p-5 rounded-lg"
              style={{ backgroundColor: 'oklch(var(--background-50))' }}
            >
              <div className="flex items-center gap-3 mb-4">
                <img
                  src={comment.avatar}
                  alt={comment.user}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-foreground-800">{comment.user}</p>
                  <p className="text-xs text-foreground-500">{comment.comic}</p>
                </div>
              </div>

              <div className="flex items-center gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`text-sm ${i < comment.rating ? 'ri-star-fill' : 'ri-star-line'}`}
                    style={{ color: i < comment.rating ? 'oklch(var(--accent-500))' : 'oklch(var(--foreground-300))' }}
                  ></i>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                "{comment.content}"
              </p>

              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">{comment.date}</span>
                <span className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}